import { useRef, useState } from "react";
// types
import { TMainPageLayoutV3 } from "../type";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import { shallowEqual, useSelector } from "react-redux";
import clsx from "clsx";


const MNPG062 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG062.rendered: ", props);

    const history = useNavigate();
    const searchRef = useRef<any>();

    const languageCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);

    const [searchToggle, setSearchToggle] = useState(false);
    const formSearchPlaceholderString = metaDataLanguageVersion("formSearchPlaceholderString", props.template?.languageVersions);

    const closeSearch = () => { setSearchToggle(false) }
    const handleSearch = () => { setSearchToggle(!searchToggle) }

    const onsubmit = ( event:any ) => {
        event.preventDefault();

        const target = event.target as typeof event.target & {
            search: { value: string }
        };

        if ( target.search.value && !isEmpty(target.search.value) ) {
            history({
                pathname: `/${languageCode}/search`,
                search: `?q=${target.search.value}`, 
            });
        }

        closeSearch();
    }

    return (
        <>
            <button
                className="search-trigger search-icon"
                onClick={handleSearch}
                aria-label="Search"
            >
                <i className="fal fa-search"></i>
            </button>

            <div
                className={clsx("search-wrap", {"open":searchToggle})}
                onClick={closeSearch}
            >
                <div className="search-inner">
                    <i
                        className="fas fa-times search-close"
                        id="search-close"
                        onClick={closeSearch}
                    />
                    <div className="search-cell">
                        <form onSubmit={onsubmit} noValidate>
                            <div className="search-field-holder">
                                <input 
                                    ref={searchRef} 
                                    name="search" 
                                    type="search" 
                                    className="main-search-input" 
                                    placeholder={formSearchPlaceholderString}
                                    onClick={(event:any) => { event.stopPropagation(); }}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
      </>
    )
}

export default MNPG062;
